import React from "react"
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { useSetContext } from "../atoms"
import { useContextSelector } from "../atoms/portale"
import { CodiceDescrizione, User, UserContext } from "../models"
import CloseIcon from '@mui/icons-material/Close'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import { Preferito } from "../models/ServiceDescriptor"
import logColors from "../utils/logColors"

const pselProv = (u: string) => u.split('.')[1].substr(0, 2)
const pselAmbi = (u: string) => u.split('.')[0]

type ContextSelectorDialogPropsType = {
    open: boolean
    user: User
    onClose: () => void,
    preferito?: Preferito,
    onSetContextPreferito?: (contesto: string) => void
}
export const ContextSelectorDialog: React.FC<ContextSelectorDialogPropsType> = ({ open, onClose, user, preferito, onSetContextPreferito }) => {
    const userCtxSel = useContextSelector()
    const setUserContext = useSetContext()
    const [provSel, setProvSel] = useState(userCtxSel.province[0])
    const [ambiSel, setAmbiSel] = useState(provSel.ambienti[0])
    const [uffiSel, setUffiSel] = useState(ambiSel.uffici[0])
    useEffect(() => {
        const handleOnShow = (userCtx: UserContext | null | undefined) => {
            if (!open || !userCtx) return;
            // console.log(`handleOnShow: Ufficio: ${userCtx.ufficio}, Provincia: ${userCtx.provincia}, UfficioCorrente: ${userCtx.ufficioCorrente}`)
            let p = userCtxSel.province[0]
            let a = p.ambienti[0]
            let u = a.uffici[0]
            if (userCtx.ufficioCorrente) {
                const pcode = userCtx.provincia !== '00' ? pselProv(userCtx.ufficioCorrente) : userCtx.provincia
                // console.log(`pcode: ${pcode}`)
                p = userCtxSel.province.find(x => x.codice === pcode) || p
                a = p.ambienti.find(x => x.codice === pselAmbi(userCtx.ufficioCorrente)) || a
                u = a.uffici.find(x => x.codice === userCtx.ufficioCorrente) || u
            } else if (userCtx.provincia) {
                p = userCtxSel.province.find(x => x.codice === userCtx.provincia) || p
                a = p.ambienti.find(x => x.codice === 'PROD') || a
                u = a.uffici.find(x => x.codice === `PROD.${userCtx.provincia}000`) || u
            }
            // console.log('userCtxSel: ', userCtxSel)
            // console.log('Contesto impostato: ', p, a, u)
            setProvSel(p)
            setAmbiSel(a)
            setUffiSel(u)
        }
        handleOnShow(user.context)
    }, [open, user.context, userCtxSel])
    const handleProvChangeSelect = (v: CodiceDescrizione | null) => {
        if (!v) return;
        const value = v.codice
        // console.log(`handleProvChangeSelect: value selected is ${value}`)
        const ambiCodice = ambiSel.codice
        const p = userCtxSel.province.find(x => x.codice === value)
        if (!p) return;
        setProvSel(p)
        let a = p.ambienti.find(x => x.codice === ambiCodice)
        if (!a) { a = p.ambienti[0] }
        if (a) {
            setAmbiSel(a)
            setUffiSel(a.uffici[0])
        }
        // console.log(`handleProvChange: `, value)
    }
    const handleAmbiChangeSelect = (value: CodiceDescrizione | null) => {
        if (!value) return
        let a = provSel.ambienti.find(x => x.codice === value.codice)
        if (a) {
            setAmbiSel(a)
            setUffiSel(a.uffici[0])
        }
        // console.log(`handleAmbiChange: `, value)
    }
    const handleUffiChangeSelect = (value: CodiceDescrizione | null) => {
        if (!value) return
        let u = ambiSel.uffici.find(x => x.codice === value.codice)
        if (u) { setUffiSel(u) }
        // console.log(`handleUffiChange: `, value)
        // console.log(`onSetContextPreferito on uffichange `, onSetContextPreferito)
    }
    const handleContextSelect = () => {
        console.log(`%chandleContextSelect: ${provSel?.codice} - ${uffiSel?.codice}`, logColors.orange14)
        if (provSel?.codice && uffiSel?.codice) {
            if (preferito) {
                // console.log('preferito scelto from contesto', preferito)
                // console.log('codice scelto from contesto', uffiSel.codice)
                // console.log('onSetContextPreferito', onSetContextPreferito)
                onSetContextPreferito && onSetContextPreferito(uffiSel.codice)
                onClose()
            } else {
                // console.log('contesto globale', uffiSel.codice)
                setUserContext(provSel.codice, uffiSel.codice)?.then(() => {
                    console.log('%cContesto impostato', logColors.orange14)
                    onClose()
                })
            }
        }
    }
    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason && reason === "backdropClick") return;
        onClose()
    }
    return (
        <Dialog onClose={handleClose} open={open} maxWidth='xs' fullWidth>
            <MySixtemaDialogTitle onClose={onClose}>
                <Typography color='primary' variant='subtitle1' component='div'>Contesto utente</Typography>
            </MySixtemaDialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
                <UserContextPartAutocomplete name="provincia" label="Provincia" value={provSel} options={userCtxSel.province} onChange={handleProvChangeSelect} variant='full' />
                <UserContextPartAutocomplete name="ambiente" label="Ambiente" value={ambiSel} options={provSel.ambienti} onChange={handleAmbiChangeSelect} />
                <UserContextPartAutocomplete name="ufficio" label="Ufficio" value={uffiSel} options={ambiSel.uffici} onChange={handleUffiChangeSelect} variant='full' />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Chiudi</Button>
                <Button disabled={!provSel || !uffiSel} onClick={handleContextSelect}>Imposta Contesto</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ContextSelectorDialog

type BootstrapDialogTitlePropsType = {
    onClose?: () => void
}

// Se si vuole la crocetta di close nell'area titolo usare questo
export const BootstrapDialogTitle: React.FunctionComponent<React.PropsWithChildren<BootstrapDialogTitlePropsType>> = ({ onClose, children }) => {
    return (
        <DialogTitle>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>

    )
}

type MySixtemaDialogTitlePropsType = {
    onClose?: () => void
}

// Se si vuole la crocetta di close nell'area titolo usare questo
export const MySixtemaDialogTitle: React.FunctionComponent<React.PropsWithChildren<MySixtemaDialogTitlePropsType>> = ({ onClose, children }) => {
    return (
        <>
            <DialogTitle sx={{ textAlign: 'center', py: 1 }}>
                {children}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            left: 4,
                            top: 4,
                            color: (theme) => theme.palette.grey[900],
                        }}
                    >
                        <CancelOutlinedIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
            <Divider />
        </>

    )
}

export type UserContextPartSelectPropsType = {
    value?: CodiceDescrizione,
    name: string,
    label: string,
    options: CodiceDescrizione[],
    onChange: (cd: CodiceDescrizione | null) => void,
    variant?: 'full' | 'descrizione' | 'codice'
}
export const UserContextPartSelect: React.FC<UserContextPartSelectPropsType> = ({ value, name, label, options, variant, onChange }) => {
    const handleChange = (event: SelectChangeEvent<any>) => {
        const v = event.target.value
        const rv = options.find(x => x.codice === v)
        if (rv) {
            onChange(rv)
        }
    }
    const getDescrizione = (o: CodiceDescrizione) => {
        switch (variant) {
            case 'full': return `${o.codice} - ${o.descrizione}`
            case 'codice': return o.codice
            case 'descrizione':
            default: return o.descrizione
        }
    }
    return (
        <FormControl variant="standard" sx={{ my: 0.5, minWidth: 120 }}>
            <InputLabel id={`ctx-${name}-select-label`}>{label}</InputLabel>
            <Select labelId={`ctx-${name}-select-label`} id={`ctx-${name}-select`} value={value?.codice} onChange={handleChange} label={label}>
                {options.map((o, idx) => <MenuItem key={idx} value={o.codice}>{getDescrizione(o)}</MenuItem>)}
            </Select>
        </FormControl>
    )
}

export const UserContextPartAutocomplete: React.FC<UserContextPartSelectPropsType> = ({ value, name, label, options, variant, onChange }) => {
    const getDescrizione = (o: CodiceDescrizione) => {
        switch (variant) {
            case 'full': return `${o.codice} - ${o.descrizione}`
            case 'codice': return o.codice
            case 'descrizione':
            default: return o.descrizione
        }
    }
    return (
        <Autocomplete id={`ctx-${name}-autocomplete`} sx={{ my: 0.5 }}
            getOptionLabel={getDescrizione}
            options={options}
            value={value}
            onChange={(event: any, newValue: CodiceDescrizione | null) => onChange(newValue)}
            renderInput={(params) => (<TextField {...params} label={label} variant="standard" />)}
        />
    )
}